/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'tr',
  Pagination: {
    items_per_page: '/ sayfa',
    jump_to: 'Git',
    jump_to_confirm: 'onayla',
    page: '',
    prev_page: 'Önceki Sayfa',
    next_page: 'Sonraki Sayfa',
    prev_5: 'Önceki 5 Sayfa',
    next_5: 'Sonraki 5 Sayfa',
    prev_3: 'Önceki 3 Sayfa',
    next_3: 'Sonraki 3 Sayfa'
  },
  DatePicker: {
    lang: {
      placeholder: 'Tarih Seç',
      rangePlaceholder: ['Başlangıç Tarihi', 'Bitiş Tarihi'],
      locale: 'tr_TR',
      today: 'Bugün',
      now: 'Şimdi',
      backToToday: 'Bugüne Geri Dön',
      ok: 'tamam',
      clear: 'Temizle',
      month: 'Ay',
      year: 'Yıl',
      timeSelect: 'Zaman Seç',
      dateSelect: 'Tarih Seç',
      monthSelect: 'Ay Seç',
      yearSelect: 'Yıl Seç',
      decadeSelect: 'On Yıl Seç',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Önceki Ay (PageUp)',
      nextMonth: 'Sonraki Ay (PageDown)',
      previousYear: 'Önceki Yıl (Control + Sol)',
      nextYear: 'Sonraki Yıl (Control + Sağ)',
      previousDecade: 'Önceki On Yıl',
      nextDecade: 'Sonraki On Yıl',
      previousCentury: 'Önceki Yüzyıl',
      nextCentury: 'Sonraki Yüzyıl'
    },
    timePickerLocale: {
      placeholder: 'Zaman Seç'
    }
  },
  TimePicker: {
    placeholder: 'Zaman Seç'
  },
  Calendar: {
    lang: {
      placeholder: 'Tarih Seç',
      rangePlaceholder: ['Başlangıç Tarihi', 'Bitiş Tarihi'],
      locale: 'tr_TR',
      today: 'Bugün',
      now: 'Şimdi',
      backToToday: 'Bugüne Geri Dön',
      ok: 'tamam',
      clear: 'Temizle',
      month: 'Ay',
      year: 'Yıl',
      timeSelect: 'Zaman Seç',
      dateSelect: 'Tarih Seç',
      monthSelect: 'Ay Seç',
      yearSelect: 'Yıl Seç',
      decadeSelect: 'On Yıl Seç',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Önceki Ay (PageUp)',
      nextMonth: 'Sonraki Ay (PageDown)',
      previousYear: 'Önceki Yıl (Control + Sol)',
      nextYear: 'Sonraki Yıl (Control + Sağ)',
      previousDecade: 'Önceki On Yıl',
      nextDecade: 'Sonraki On Yıl',
      previousCentury: 'Önceki Yüzyıl',
      nextCentury: 'Sonraki Yüzyıl'
    },
    timePickerLocale: {
      placeholder: 'Zaman Seç'
    }
  },
  global: {
    placeholder: 'Lütfen seçiniz'
  },
  Table: {
    filterTitle: 'Menü Filtrele',
    filterConfirm: 'Tamam',
    filterReset: 'Sıfırla',
    selectAll: 'Hepsini Seç',
    selectInvert: 'Tersini Seç',
    sortTitle: 'Sırala'
  },
  Modal: {
    okText: 'Tamam',
    cancelText: 'İptal',
    justOkText: 'Tamam'
  },
  Popconfirm: {
    okText: 'Tamam',
    cancelText: 'İptal'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Arama',
    itemUnit: 'Öğe',
    itemsUnit: 'Öğeler'
  },
  Upload: {
    uploading: 'Yükleniyor...',
    removeFile: 'Dosyayı kaldır',
    uploadError: 'Yükleme Hatası',
    previewFile: 'Dosyayı Önizle',
    downloadFile: 'Dosyayı indir'
  },
  Empty: {
    description: 'Veri Yok'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'düzenle',
    copy: 'kopyala',
    copied: 'kopyalandı',
    expand: 'genişlet'
  }
};
